import axiosInstance from "api/axiosInstance";

import type { CertificateUpload, CertificateListParams, CertificateApproveRequest } from "api/types/certification.types";

const BASE = "/server/buccl_user/api/v1/certificates/";

export const certificationsService = {
  // 자격증 목록 조회 (default: approval_status=pending)
  list: (params?: CertificateListParams) => axiosInstance.get<CertificateUpload[]>(BASE, { params }),

  // 승인 또는 거절 (단일 엔드포인트, action 으로 구분)
  action: (id: number, payload: CertificateApproveRequest) => axiosInstance.post(`${BASE}${id}/approve/`, payload),

  // 자격증 영구 삭제 (hard delete, 관리자 전용)
  remove: (id: number) => axiosInstance.delete(`${BASE}${id}/`),
};
